import { useMemo, useState } from 'react';
import api from '../../../services/api';
import LoadingBackdrop from '../../../load/loadingBackdrop';
import { useSelector } from 'react-redux';
import ImageBannerEdit from './imageBannerEdit';

const CloseIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        className="tw-h-4 tw-w-4"
        aria-hidden="true"
    >
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 6l12 12M18 6 6 18" />
    </svg>
);

const PhotoIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        className="tw-h-10 tw-w-10"
        aria-hidden="true"
    >
        <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 7.5A2.5 2.5 0 0 1 7 5h1.2a2 2 0 0 0 1.4-.6l.8-.8a2 2 0 0 1 1.4-.6h1.4a2 2 0 0 1 1.4.6l.8.8a2 2 0 0 0 1.4.6H17a2.5 2.5 0 0 1 2.5 2.5v9A2.5 2.5 0 0 1 17 19.5H7a2.5 2.5 0 0 1-2.5-2.5z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 13a3 3 0 1 0 6 0 3 3 0 0 0-6 0Z" />
    </svg>
);

const CreateBanner = (props) => {
    const user = useSelector(state => state.account.user);
    const [banner, setBanner] = useState(props?.banner || {});
    const [open, setOpen] = useState(false);
    const [preview, setPreview] = useState(false);

    const imagePreview = useMemo(() => {
        if (banner?.imagem instanceof File) {
            return URL.createObjectURL(banner.imagem);
        }
        return banner?.imagem || props?.banner?.imagem || '';
    }, [banner?.imagem, props?.banner?.imagem]);

    const hasImage = Boolean(imagePreview);

    function HandleChange(e) {
        const { name, value, files } = e.target;
        setBanner((current) => ({
            ...current,
            [name]: files?.[0] ?? value,
        }));
    }

    async function HandleCreateBanner() {
        const formData = new FormData();
        formData.append('userId', user._id);
        formData.append('titulo', banner?.titulo ?? '');
        formData.append('descricao', banner?.descricao ?? '');
        formData.append('imagem', banner?.imagem);
        formData.append('status', 'Activo');

        setOpen(true);
        props.seterrorMessage('');
        props.setMessage('');

        try {
            if (props?.banner) {
                const res = await api.put('/carousel/edit', {
                    ...banner,
                    userId: user._id,
                    bannerId: props.banner._id,
                });
                props.setMessage(res.data.msg);
                props.setEditarBanner(false);
            } else {
                const res = await api.post('/carousel/create', formData);
                props.setMessage(res.data.msg);
                props.setCreateBanner(false);
            }
        } catch (error) {
            props.seterrorMessage(error?.response?.data?.message || 'Não foi possível salvar o banner.');
        } finally {
            setOpen(false);
        }
    }

    const resetAndClose = () => {
        props.setCreateBanner(false);
        props.setEditarBanner?.(false);
    };

    return (
        <>
            <LoadingBackdrop open={open} text={'A criar Banner. Aguarde!'} />

            {!preview ? (
                <div className="tw-space-y-6">
                    <div className="tw-flex tw-items-start tw-justify-between tw-gap-4">
                        <div>
                            <p className="tw-text-sm tw-font-medium tw-uppercase tw-tracking-[0.2em] tw-text-slate-500">
                                Banner
                            </p>
                            <h2 className="tw-mt-1 tw-text-2xl tw-font-semibold tw-text-slate-900">
                                {props.title}
                            </h2>
                        </div>

                        <button
                            type="button"
                            onClick={resetAndClose}
                            className="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-bg-slate-100 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-slate-700 tw-transition hover:tw-bg-slate-200"
                        >
                            <CloseIcon />
                            Fechar
                        </button>
                    </div>

                    {props?.banner ? (
                        <div className="tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-p-4">
                            <ImageBannerEdit
                                foto={props.banner.imagem}
                                bannerId={props.banner._id}
                                setEditarBanner={props.setEditarBanner}
                            />
                        </div>
                    ) : (
                        <div className="tw-rounded-2xl tw-border tw-border-dashed tw-border-slate-300 tw-bg-white tw-p-4">
                            <label htmlFor="imagem" className="tw-group tw-block tw-cursor-pointer">
                                <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-rounded-xl tw-bg-slate-50 tw-p-6 tw-text-center tw-transition group-hover:tw-bg-slate-100">
                                    {hasImage ? (
                                        <div className="tw-relative tw-w-full tw-overflow-hidden tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-shadow-sm">
                                            <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-start  tw-to-transparent tw-p-4 tw-text-left tw-text-white">
                                                <div className="tw-max-w-[90%] tw-space-y-1 tw-self-center">
                                                    {banner?.titulo && (
                                                        <p className="tw-text-left tw-text-lg tw-font-semibold tw-leading-6">
                                                            {banner.titulo}
                                                        </p>
                                                    )}
                                                    {banner?.descricao && (
                                                        <p className="tw-text-left tw-text-sm tw-leading-6 tw-text-white/90">
                                                            {banner.descricao}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                            <img
                                                src={imagePreview}
                                                alt="Imagem do banner"
                                                className="tw-h-[280px] tw-w-full tw-object-cover"
                                            />
                                        </div>
                                    ) : (
                                        <>
                                            <div className="tw-flex tw-h-16 tw-w-16 tw-items-center tw-justify-center tw-rounded-full tw-bg-white tw-text-slate-500 tw-shadow-sm">
                                                <PhotoIcon />
                                            </div>
                                            <div>
                                                <p className="tw-text-base tw-font-semibold tw-text-slate-800">
                                                    Clique para selecionar a imagem
                                                </p>
                                                <p className="tw-mt-1 tw-text-sm tw-text-slate-500">
                                                    Tamanho recomendado: 1000x650px, formato JPG ou PNG.
                                                </p>
                                            </div>
                                        </>
                                    )}
                                </div>
                                <input
                                    accept="image/png, image/jpg, image/jpeg"
                                    type="file"
                                    name="imagem"
                                    id="imagem"
                                    className="tw-hidden"
                                    onChange={HandleChange}
                                />
                            </label>
                        </div>
                    )}

                    <div className="tw-grid tw-gap-4 md:tw-grid-cols-2">
                        <div className="tw-space-y-2">
                            <label htmlFor="titulo" className="tw-text-sm tw-font-medium tw-text-slate-700">
                                Título
                            </label>
                            <input
                                id="titulo"
                                type="text"
                                name="titulo"
                                defaultValue={banner?.titulo}
                                onChange={HandleChange}
                                className="tw-w-full tw-rounded-lg tw-border tw-border-slate-300 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-[#85287e] focus:tw-ring-2 focus:tw-ring-[#85287e]/20"
                                placeholder="Ex.: Campanha de vacinação"
                            />
                        </div>

                        <div className="tw-space-y-2 md:tw-col-span-2">
                            <label htmlFor="descricao" className="tw-text-sm tw-font-medium tw-text-slate-700">
                                Descrição
                            </label>
                            <textarea
                                id="descricao"
                                name="descricao"
                                defaultValue={banner?.descricao ?? banner?.subTitulo}
                                onChange={HandleChange}
                                rows={4}
                                className="tw-w-full tw-resize-none tw-rounded-lg tw-border tw-border-slate-300 tw-bg-white tw-px-3 tw-py-2 tw-text-sm tw-text-slate-700 tw-outline-none focus:tw-border-[#85287e] focus:tw-ring-2 focus:tw-ring-[#85287e]/20"
                                placeholder="Escreva uma descrição curta e clara"
                            />
                        </div>
                    </div>

                    <div className="tw-flex tw-flex-wrap tw-justify-end tw-gap-3">
                        <button
                            type="button"
                            onClick={resetAndClose}
                            className="tw-rounded-lg tw-border tw-border-slate-300 tw-bg-white tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-slate-700 tw-transition hover:tw-bg-slate-50"
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            onClick={() => setPreview(true)}
                            className="tw-rounded-lg tw-border tw-border-[#85287e] tw-bg-white tw-px-4 tw-py-2 tw-text-sm tw-font-medium tw-text-[#85287e] tw-transition hover:tw-bg-[#85287e]/5"
                        >
                            Preview
                        </button>
                        <button
                            type="button"
                            disabled={!banner?.imagem}
                            onClick={HandleCreateBanner}
                            className="tw-inline-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-[#85287e] tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-white tw-transition hover:tw-bg-[#6f2167] disabled:tw-cursor-not-allowed disabled:tw-opacity-60"
                        >
                            Salvar
                        </button>
                    </div>
                </div>
            ) : (
                <div className="tw-space-y-4">
                    <div className="tw-flex tw-items-center tw-justify-between">
                        <h3 className="tw-text-xl tw-font-semibold tw-text-slate-900">Preview</h3>
                        <button
                            type="button"
                            onClick={() => setPreview(false)}
                            className="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-full tw-bg-slate-100 tw-px-3 tw-py-2 tw-text-sm tw-font-medium tw-text-slate-700 hover:tw-bg-slate-200"
                        >
                            <CloseIcon />
                            Voltar
                        </button>
                    </div>

                    <div className="tw-rounded-2xl tw-border tw-border-slate-200 tw-bg-white tw-p-4 tw-shadow-sm">
                        {hasImage ? (
                            <div className="tw-relative tw-overflow-hidden tw-rounded-xl tw-border tw-border-slate-200">
                                <img
                                    src={imagePreview}
                                    alt="Preview do banner"
                                    className="tw-h-[320px] tw-w-full tw-object-cover"
                                />
                                <div className="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-start tw-bg-gradient-to-t  tw-to-transparent tw-p-5 tw-text-left tw-text-white">
                                    <div className="tw-max-w-[90%] tw-space-y-1 tw-self-center">
                                        {banner?.titulo && (
                                            <p className="tw-text-left tw-text-2xl tw-font-semibold tw-leading-7 sm:tw-text-3xl">
                                                {banner.titulo}
                                            </p>
                                        )}
                                        {banner?.descricao && (
                                            <p className="tw-text-left tw-text-sm tw-leading-6 tw-text-white/90 sm:tw-text-base">
                                                {banner.descricao}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="tw-flex tw-h-[320px] tw-items-center tw-justify-center tw-rounded-xl tw-bg-slate-50 tw-text-slate-500">
                                Sem imagem selecionada
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default CreateBanner;
